import { useSelector } from "react-redux";
import { UserProgress } from "../model/progress";
import { RootState } from "../reducers/store";
import { AlertView } from "./alert";
import Typography from "@mui/material/Typography";
import { useEffect, useState } from "react";
import { Program } from "../model/program";
import { TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, Tooltip } from "@mui/material";
import { UserProgressCourseRow } from "./userprogresscourse";
import { User } from "../model/user";
import { Course } from "../model/course";

export const UserProgressView = () => {
    const [errorMessage, setError] = useState<string | null>(null);

    const currentProgram: Program | null = useSelector((state: RootState) => state.programs.currentProgram);
    const allCourses: Course[] = useSelector((state: RootState) => state.courses.courses);
    const currentCourses = allCourses.filter((course) => course.programId == currentProgram?.id)

    const currentGroupUsers: User[] = useSelector((state: RootState) => state.users.currentGroupUsers);
    
    const currentUsersProgramProgress: UserProgress[] | null = useSelector((state: RootState) => state.progress.currentUsersProgramProgress);
    
    let startedUserIds: string[] | undefined = currentUsersProgramProgress?.map(progress => progress.userId);
    let noDataUsers = currentGroupUsers.filter(user => !startedUserIds?.includes(user.id));

    return (
        <div style={{padding: 16}}>
            <AlertView error={errorMessage}/>
            <Typography sx={{ marginBottom: 2 }} align='left'>In Progress</Typography>

            <TableContainer component={Paper} sx={{ marginBottom: 5 }} >
                <Table aria-label="collapsible table">
                    <TableHead>
                    <TableRow>
                        <TableCell />
                        <TableCell>
                            <Tooltip title="Progress is measured by the amount of chapters the user has completed">
                                <span style={{ cursor: 'help' }}>
                                    Progress
                                </span>
                            </Tooltip>
                        </TableCell>
                        <TableCell>User</TableCell>
                    </TableRow>
                    </TableHead>
                    <TableBody>
                    {
                        currentUsersProgramProgress?.map((userProgress) => (
                            userProgress.userId ? 
                                <UserProgressCourseRow
                                    key={userProgress.userId} 
                                    userProgress={userProgress} 
                                    currentProgram={currentProgram} 
                                    currentCourses={currentCourses} 
                                />:
                                <></>
                        ))
                    }
                    </TableBody>
                </Table>
            </TableContainer>

            {
                currentProgram?.clientName != "Public" ? (
                    <>
                        <Typography sx={{ marginBottom: 2 }} align='left'>No Progress</Typography>
                        <TableContainer component={Paper}>
                            <Table aria-label="regular table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell/>
                                        <TableCell>User</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        noDataUsers.map((user) => (
                                            <TableRow key={user.id}>
                                                <TableCell width={60}></TableCell>
                                                <TableCell>{user.email}</TableCell>
                                            </TableRow>
                                        ))
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </>
                ): <></>
            }
        </div>
    )
}